export default __webpack_public_path__ + "static/media/404-webapp-01.ef7a8cd0.png";